import customFetch from "services/api";

/**
 * The browser's FCM registration token, registered against the signed-in admin so
 * the backend's `push` channel reaches this browser alongside the mobile apps.
 * Imperative rather than a React Query mutation: these fire from the FCM setup
 * flow, not from a component's render.
 */
export const savePushToken = (fcmToken) =>
  customFetch("dashboard/save-fcm-token", {
    method: "POST",
    body: { fcm_token: fcmToken },
  });

export const deletePushToken = (fcmToken) =>
  customFetch("dashboard/delete-fcm-token", {
    method: "POST",
    body: { fcm_token: fcmToken },
  });
